import { createNamedContext } from '@core/createNamedContext'

export interface CookieNoteContextValue {
  openCookieNote: () => void
  allowCookieNote: boolean
}

export const CookieNoteContext = createNamedContext<CookieNoteContextValue>(
  'CookieNoteContext',
  {
    openCookieNote: () => null,
    allowCookieNote: true,
  }
)
